import PowMon from "../../logic/powMon";
import PrognosisPQValues from "../../models/metMap/powmon/prognosisPQValues";
import PrognosisBarChart from "../../metMap/powmon/prognosisBarChart";
export default class PowMonWidget {
    constructor(containerId, dotNetRef, powmonSettings) {
        PowMonWidget.dotNetRef = dotNetRef;
        PowMonWidget.parsePowMonSettings(powmonSettings);
        PowMon.setScale(PowMon.level1);
        this._barChart = new PrognosisBarChart(containerId);
    }
    update(rawPrognosis) {
        const prognosis = new PrognosisPQValues(new Date(rawPrognosis.prognosisForTime), rawPrognosis.pVal, rawPrognosis.qVal);
        this._barChart.updateCharts(prognosis);
    }
    static parsePowMonSettings(settings) {
        if (settings && settings.isShowLevel1 && settings.level1_Limit) {
            PowMon.level1 = settings.level1_Limit;
        }
        if (settings && settings.isShowLevel2 && settings.level2_Limit) {
            PowMon.level2 = settings.level2_Limit;
        }
        if (settings && settings.isShowLevelMax && settings.levelMax_Limit) {
            PowMon.levelMax = settings.levelMax_Limit;
        }
        if (settings && settings.isShowLevelReac && settings.levelReacPos_Limit) {
            PowMon.levelQMax = settings.levelReacPos_Limit;
        }
        if (settings && settings.isShowLevelReacNegative && settings.levelReacNeg_Limit) {
            PowMon.levelQMin = settings.levelReacNeg_Limit;
        }
        if (settings) {
            PowMon.showProduction = settings.isShowProdChart;
        }
        if (settings && settings.timeAggregationType) {
            PowMon.noOfPrognosisMinutes = settings.timeAggregationType === 3 ? 60 : 15;
        }
        //PowMon.mpointPowerGroups = powmonSettingsReply.mpointPowerGroups;
        //PowMon.mpointPowerGroupsProd = powmonSettingsReply.mpointPowerGroupsProd;
    }
}
